import { ContactResource, ContactTypeList } from '../../../classes/Api/Contact';

export default {
    data() {
        return {
            isLoading: false,
            noResults: true,
            options: [],
        }
    },
    methods: {
        onQueryChange: _.debounce(function(query) {
            ContactResource.cancelCurrentRequest();

            if (query.length >= 2) {
                this.isLoading = true;

                let contactCancelToken = ContactResource.createCancelToken()

                let params = {}

                if (this.relationsToLoad) {
                    params.with = this.relationsToLoad
                }

                ContactResource.search(query, this.type, params, { cancelToken: contactCancelToken }).then(response => {
                    this.noResults = false;
                    this.isLoading = false;

                    if (response.data.length === 0) {
                        this.noResults = true;
                    }

                    this.options = response.data;

                    this.$emit('contact-search-complete');
                }, error => handleApiError).catch(error => {
                    //
                })
            } else {
                this.options = [];
                this.loading = false;
            }
        }, 100)
    }
}